import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { GetProductReviewsById } from "../../Admin/callApi/shop";
import { Box, Rating } from "@mui/material";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";

export const AllReviews = () => {
  const { id } = useParams();
  const location = useLocation();
  const [reviews, setReviews] = useState([]);
  const dispatch = useDispatch();
  // fetch product reviews
  const GetProductReviews = (id) => {
    if (id !== null) {
      GetProductReviewsById(id)
        .then((res) => {
          dispatch(setLoading(true));
          res.length !== 0 && setReviews(res);
          dispatch(setLoading(false));
        })
        .catch((error) => {
          console.error("Error fetching the data", error);
          dispatch(setLoading(false));
        });
    }
  };

  useEffect(() => {
    GetProductReviews(id);
  }, [location]);

  return (
    reviews &&
    reviews.length !== 0 && (
      <div className="reviews-div">
        <h1 className="product-name">{reviews[0]?.ProductID}</h1>

        <div className="product-review-div">
          {reviews.map((item, index) => {
            return (
              <div className="product-review-card" key={index}>
                <p className="fullname">{item.FullName}</p>
                <Box component="fieldset" borderColor="transparent">
                  <Rating name="read-only" value={item.Rating} readOnly />
                </Box>
                <p className="product-review">{item.Review}</p>
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};
